<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<div class="d-flex gap-8 content-height">
  <div class="d-flex gap-8 h-100 flex-column flex-grow-1">
    <mat-card appearance="outlined" class="h-50">
      <mat-card-content>
        <app-vehicle-portfolio-report></app-vehicle-portfolio-report>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" class="h-50">
      <mat-card-content>
        <app-portfolio-variance-rpt></app-portfolio-variance-rpt>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="d-flex gap-8 h-100 flex-column flex-grow-1">
    <mat-card appearance="outlined" class="h-50 content-width">
      <mat-card-content>
        <app-propulsion-portfolio-report>
        </app-propulsion-portfolio-report>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" class="h-50 content-width">
      <mat-card-content>
        <app-portfolio-archive-report></app-portfolio-archive-report>
      </mat-card-content>
    </mat-card>
  </div>
</div>

